// 1. Imports
import { Container, Stack } from "@mui/material";
import { Page } from "../../../../components";
import HeaderBreadcrumbs from "../../../../components/header-breadcrumbs";
import { NewMessageComposeComponent } from "../../../../components/message-center/v2/send-a-message/new-message-compose-component";

// 2. Component Def
export const AutomatedReminderConfigureScreen = () => {
    return (
        <Page title="POM Safe - Configure Reminder">
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <HeaderBreadcrumbs
                        heading="New automated reminder"
                        links={[
                            { name: 'Message Center', href: '/messages' },
                            { name: 'Select Recipients', href: '/messages/automated-reminders/recipients' },
                            { name: 'Configure Reminder', href: '/messages/automated-reminders/configure' },
                        ]}
                        activeLast={false}
                    />
                </Stack>

                <NewMessageComposeComponent mode="reminder" />
            </Container>
        </Page>
    )
}